# directive to give a source an info button
# use like:
#   <div source-info engine="worker.engine" krakensnapshot="worker.kraken_snapshot" ng-if="sources.length == 1"></div>

require 'angular'

app = angular.module('workflow.app')
app.directive('sourceInfo', require('./SourceInfo'))
